import { useQuery } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'
import type { ApiKey, ListApiKeysResponse } from 'shared/src'

export const apiKeysListQueryKey = () => ['api-keys', 'list'] as const

export function useApiKeysListQuery() {
  return useQuery({
    queryKey: apiKeysListQueryKey(),
    queryFn: async (): Promise<ApiKey[]> => {
      const result = (await fetchApi<ListApiKeysResponse>({
        endpoint: '/api/keys',
      })) as ListApiKeysResponse | null
      return result?.data ?? []
    },
  })
}
